/**
* @description: 积分记录
*/
<template>
    <div class="finance_box" ref="myElementRef">
        <div ref="searchBox">
            <hc-search :data="searchData" @serch="getSearch" />
        </div>
        <!-- 表格 -->
        <div class="table_box">
            <hc-table :tableData="state.tableData" :column="state.tableHeader" :offsetHeight="state.offsetHeight"
                :maxPage="maxPage"
                @pageChange="pageChange" @limitChange="limitChange">
            </hc-table>
        </div>
        <!-- 新增 -->
        <!-- <EditSpecial ref="addLocation" :title="state.title" /> -->
    </div>
</template>

<script setup>
import hcSearch from "@/components/hc-search/index.vue";
import hcTable from "@/components/hc-table/index.vue";
import { onMounted, reactive, ref, nextTick, onUnmounted, onActivated, toRaw } from "vue";
// import EditSpecial from "./components/editSpecial.vue";

import { pageListApi } from "@/api/score/score.js";
import { listToMap } from "@/utils/utils";
import { usePageI18n, t } from "@/composables/usePageI18n.js";
const myElementRef = ref();
const searchBox = ref();
const addLocation = ref();


let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);
const searchData = reactive([
    {
        label: "关键词",
        type: "input",
        value: "",
        field: 'keywords',
        placeholder: "姓名/账号/电话",
    },
    {
        label: "时间",
        type: "daterange", // date
        value: [],
        field: 'time',
        seditem: '',
        enditem: '',
    },
]);

const statusOptions = reactive([
    { label: "已发布", value: 1 },
    { label: "未发布", value: 0 }
])

const state = reactive({
    title: "",
    column: [
        {
            prop: "id",
            show: false,
            label: "记录ID",
        },
        {
            show: true,
            type: "index",
            label: "序号",
            width: 80,
        },
        {
            prop: "real_name",
            show: true,
            label: "记录人姓名",
        },
        {
            prop: "username",
            show: true,
            label: "记录人用户名",
        },
        {
            prop: "mobile",
            show: true,
            label: "记录人手机",
        },
        {
            prop: "reason",
            show: true,
            label: "积分原因",
        },
        {
            prop: "points",
            show: true,
            label: "分值",
        },
        {
            prop: "created_at",
            show: true,
            label: "创建时间",
        },
        // {
        //     prop: "operation",
        //     show: true,
        //     label: "操作",
        // },
    ],
    offsetHeight: 0,
    tableHeader: [],
    tableData: [
        {
            //   "reason": "技能学习",
            //   "user_id": 1,
            //   "mobile": "13456214521",
            //   "created_at": "2025-05-08 19:38:41",
            //   "change_type": 1,
            //   "real_name": "张三",
            //   "id": 1,
            //   "points": 10,
            //   "username": "jishou0001"
        }
    ]
});

const init = () => {
    getSearch(searchData)
};

// 动态改变表头
const change = (item) => {
    tableHeaderFn();
};

const offHeighths = () => {
    if (myElementRef.value) {
        state.offsetHeight =
            myElementRef.value?.offsetHeight - 90 - searchBox.value?.offsetHeight;
    }
};

const pageChange = (currentPage) => {
    page.value = currentPage;
    getSearch(searchData)
}

const limitChange = (currentLimit) => {
    limit.value = currentLimit;
    getSearch(searchData)
}

onMounted(() => {
    try {
        nextTick(() => {
            offHeighths();
        });
        window.onresize = () => {
            nextTick(() => {
                offHeighths();
            });
        };
        tableHeaderFn();
        applyLabels();
        init();
    } catch { }
});

onUnmounted(() => {
    window.onresize = null;
});

// 查询过来的数据
const getSearch = (params) => {
    const timeData = toRaw(searchData.filter(i => i.field === 'time')[0] ?? {}).value ?? []
    const form = listToMap(toRaw(params), { value: 'value', key: 'field' })
    const requestParams = {
        page: page.value,
        limit: limit.value,
        ...form,
        "stime": timeData[0] ?? '',
        "etime": timeData[1] ?? '',
    }
    state.loading = true
		pageListApi(JSON.stringify(requestParams)).then(res => {
        maxPage.value = res?.maxPage ?? 0;
        state.tableData = res?.data?.map(item => {
            return {
                ...item,
                status: listToMap(statusOptions, {})[item.status],
            }
        }) ?? []
    }).finally(() => {
		state.loading = false
	})
};

const applyLabels = () => {
    searchData[0].label = t('field.keywords');
    searchData[0].placeholder = t('scoreRecord.keywordPlaceholder');
    searchData[1].label = t('scoreRecord.time');
    state.column[1].label = t('table.index');
    state.column[2].label = t('scoreRecord.recorderName');
    state.column[3].label = t('scoreRecord.recorderUsername');
    state.column[4].label = t('scoreRecord.recorderMobile');
    state.column[5].label = t('scoreRecord.reason');
    state.column[6].label = t('scoreRecord.points');
    state.column[7].label = t('scoreRecord.createdAt');
    tableHeaderFn();
};
usePageI18n(applyLabels);

// 表头筛选
const tableHeaderFn = () => {
    state.tableHeader = state.column.filter((v) => {
        if (v.show) {
            return v.show == true;
        } else {
            v.show = false;
        }
    });
};
</script>

<style lang="less" scoped>
.finance_box {
    flex: 1;
    overflow: auto;
    background-color: #fff;
    border-radius: 6px;
    padding: 10px;
    margin-right: 10px;
}

.btn_box {
    height: 40px;
    display: flex;
}

.table_box {
    width: 100%;
}

/deep/.el-button-group .el-button--primary:first-child {
    background-color: #1e6aed;
    border: none;
}

.serBtn {
    margin-left: 10px;
    background-color: #f0f0f0;
    color: #000;
    border: none;
}

.serBtn:hover {
    background-color: #f0f0f0;
    color: #000;
}

.opBtn {
    // margin: 0 !important;
    margin: 0 10px 0 0;
}

.opBtn:hover {
    color: #e6a755;
}
</style>
